export default "__VITE_ASSET__SLx$QC2e__"